import * as A from "fp-ts/Array";
import * as Eq from "fp-ts/Eq";
import Fuse from "fuse.js";

type MapToType<T, U> = { [K in keyof T]: U };

export const partitionByPredicates = <
  T,
  U extends readonly ((value: T) => boolean)[]
>(
  arr: T[],
  ...predicates: U
): [...MapToType<U, T[]>, T[]] => {
  const predicateArrays: T[][] = predicates.map(() => []);
  const otherArray: T[] = [];

  for (const value of arr) {
    const matchingPredicate = predicates.findIndex((predicate) =>
      predicate(value)
    );
    if (matchingPredicate < 0) {
      otherArray.push(value);
    } else {
      predicateArrays[matchingPredicate].push(value);
    }
  }

  return [...predicateArrays, otherArray] as any;
};

/**
 * Remove duplicates from an array based on predicate. Keeps first instance of
 * unique element.
 */
export const uniqBy = <T>(equals: Eq.Eq<T>["equals"]) =>
  A.uniq(Eq.fromEquals<T>(equals));

export const fuseSearch = <T>(
  array: T[],
  pattern: string,
  keys: Fuse.FuseOptionKeyObject<T>[]
) => {
  const fuse = new Fuse(array, {
    keys,
    includeScore: true,
    ignoreLocation: true,
  });

  const result = fuse.search(pattern);

  return result
    .filter(({ score }) => score && score <= 0.3)
    .map(({ item }) => item);
};
